import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useI18n } from "@/i18n";

export const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer className="mt-24 border-t border-[#EEF0F6] bg-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo className="h-12 w-[164px]" />
          <p className="mt-3 max-w-sm text-sm text-[#64748B]">{t("footer.tagline")}</p>
          <p className="mt-4 inline-block rounded-full bg-[#FFF0EE] px-3 py-1 text-xs font-semibold text-[#E0533F]" data-testid="footer-demo-notice">{t("footer.demo")}</p>
        </div>
        <div>
          <p className="font-display text-sm font-bold text-[#3B1272]">Juppo</p>
          <ul className="mt-3 space-y-2 text-sm text-[#64748B]">
            <li><Link to="/cerca?area=outlet" className="hover:text-[#3B1272]">Juppo Outlet</Link></li>
            <li><Link to="/cerca?area=market" className="hover:text-[#3B1272]">Juppo Market</Link></li>
            <li><Link to="/cerca?exchange=true" className="hover:text-[#3B1272]">{t("areas.scambi.t")}</Link></li>
            <li><Link to="/cerca?area=pro" className="hover:text-[#3B1272]">Juppo Pro</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-display text-sm font-bold text-[#3B1272]">{t("footer.legal")}</p>
          <ul className="mt-3 space-y-2 text-sm text-[#64748B]">
            <li><Link to="/informative" data-testid="footer-legal-link" className="hover:text-[#3B1272]">{t("footer.privacy")}</Link></li>
            <li><Link to="/informative" className="hover:text-[#3B1272]">{t("footer.terms")}</Link></li>
            <li><Link to="/informative" className="hover:text-[#3B1272]">{t("footer.cookies")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#EEF0F6] py-5 text-center text-xs text-[#94A3B8]">© {year} Juppo. {t("footer.rights")}</div>
    </footer>
  );
};
